(function () {
    if (typeof console.debug == 'undefined') {
        console.debug = console.log;
    }

    if (typeof console.error == 'undefined') {
        console.error = console.log;
    }

    //noinspection JSUnresolvedVariable
    console.log("Configure ajax");
    $.ajaxSetup({
        headers: {
            'X-CSRFToken': configuration.csrf_token || '',
            crossDomain: true
        },
        dataType: "json",
        contentType: "application/json"
    });
})()
